/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Refresh_Aria_LabelInputs */

const en_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh commit list`)
};

const fr_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser la liste des commits`)
};

const de_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit-Liste aktualisieren`)
};

const it_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna l'elenco dei commit`)
};

const ru_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить список коммитов`)
};

const es_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar la lista de confirmaciones`)
};

const zh_cn2_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新提交列表`)
};

const ja_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミットリストを更新`)
};

const hi_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कमिट सूची को रीफ़्रेश करें`)
};

const pt_pt2_snapshot_history_refresh_aria_label = /** @type {(inputs: Snapshot_History_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar lista de commits`)
};

/**
* | output |
* | --- |
* | "Refresh commit list" |
*
* @param {Snapshot_History_Refresh_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_refresh_aria_label = /** @type {((inputs?: Snapshot_History_Refresh_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Refresh_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_refresh_aria_label(inputs)
	if (locale === "de") return de_snapshot_history_refresh_aria_label(inputs)
	if (locale === "it") return it_snapshot_history_refresh_aria_label(inputs)
	if (locale === "ru") return ru_snapshot_history_refresh_aria_label(inputs)
	if (locale === "es") return es_snapshot_history_refresh_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_refresh_aria_label(inputs)
	if (locale === "ja") return ja_snapshot_history_refresh_aria_label(inputs)
	if (locale === "hi") return hi_snapshot_history_refresh_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_refresh_aria_label(inputs)
	return en_snapshot_history_refresh_aria_label(inputs)
});